export default __webpack_public_path__ + "static/media/gmapsBgImage.08e42bea.png";